import { chakra, SystemStyleObject } from '@chakra-ui/react'

import { EmptyTranscriptionIcon } from 'src/components/icons'

const templateContentBaseStyle: SystemStyleObject = {
    fontSize: 'lg',
    lineHeight: 1.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    alignItems: 'center',
    textAlign: 'center',
    paddingX: 6,
}

export const TemplateContent = chakra('div', {
    baseStyle: templateContentBaseStyle,
})

export const TemplateTitle = chakra('h2', {
    baseStyle: {
        margin: 0,
        fontSize: 'lg',
        lineHeight: 1.5,
        fontWeight: 600,
    },
})

export const TemplateDescription = chakra('div', {
    baseStyle: {
        fontSize: 'lg',
        lineHeight: 1.5,
    },
})

export const ReadyToConnectContent = chakra('div', {
    baseStyle: ({ theme }) => ({
        ...templateContentBaseStyle,
        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            height: '100%',
            alignItems: 'flex-start',
        },
    }),
})

export const ReadyToConnectSessionTitle = chakra('h2', {
    baseStyle: {
        // `margin: 0` clears the margin the heading tag introduces and must stay before
        // `marginBottom`, which pins the rest of the column to the bottom at tablet width.
        margin: 0,
        marginBottom: 'auto',
        fontSize: '2xl',
        lineHeight: 1.5,
        fontWeight: 600,
        paddingTop: 2,
    },
})

export const StyledTranscriptIcon = chakra(EmptyTranscriptionIcon, {
    baseStyle: {
        marginBottom: 6,
    },
})
